import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.research.list');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ResearchImportState } from "src/libs/research-import";

@Component({
    selector: 'wiz-portal-gsdcadmin-research-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.research.list/view.scss */
/* src/app/portal.gsdcadmin.research.list/view.scss: no such file or directory */`],
})
export class PortalGsdcadminResearchListComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    public researchs: any = [];
    public loaded: boolean = false;

    public searchTerm: any = "";

    public pagination: any = {
        page: 1,
        end: 1,
        start: 1,
    };
    public total = 0;
    public importState = new ResearchImportState(this.service, params => wiz.call('excel', params), async () => {
        await this.load();
        if (!this.loaded) throw new Error('RESEARCH_LIST_UNAVAILABLE');
    });

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership('admin', "/landing");
        await this.load();
    }

    public async load() {
        this.loaded = false;
        const { code, data } = await wiz.call("load", { text: this.searchTerm, page: this.pagination.page });
        if (code != 200) return await this.service.alert.error("Error!");
        this.researchs = data.rows;
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total;
        this.loaded = true;
        await this.service.render();
    }

    public ngOnDestroy() { this.importState.dispose(); }

    public async download() {
        let download = wiz.url('download')
        window.location.href = download;
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.load();
    }
}

export default PortalGsdcadminResearchListComponent;